/*
 * Places on the 3D export globe. The origin is the Zagros range; each destination stands for one export region.
 * Kept free of 3D code so the page can render the labels without loading the 3D library.
 */

export type GlobePlace = {
    id: string
    name: string
    lat: number
    lon: number
}

export const GLOBE_ORIGIN: GlobePlace = { id: 'zagros', name: 'زاگرس، ایران', lat: 32.6, lon: 50.0 }

export const GLOBE_DESTINATIONS: GlobePlace[] = [
    { id: 'europe', name: 'اروپا', lat: 50.1, lon: 8.7 },
    { id: 'asia', name: 'آسیا', lat: 31.2, lon: 121.5 },
    { id: 'middle-east', name: 'خاورمیانه', lat: 24.7, lon: 46.7 },
    { id: 'africa', name: 'آفریقا', lat: -1.3, lon: 36.8 },
    { id: 'americas', name: 'آمریکا', lat: 40.7, lon: -74.0 },
    { id: 'australia', name: 'استرالیا', lat: -33.9, lon: 151.2 }
]

export const GLOBE_PLACES: GlobePlace[] = [GLOBE_ORIGIN, ...GLOBE_DESTINATIONS]

export const GLOBE_DESCRIPTION = `کره زمین سه‌بعدی که مسیر ارسال محصولات از کوه‌های زاگرس را به ${GLOBE_DESTINATIONS.map(place => place.name).join('، ')} نشان می‌دهد.`
